import type { LogoBrand } from '@brighterly/lib-lumee-ui'

import { AppBrand } from '@ts-brand/enums'

type AppLogoDomainBrand = Exclude<LogoBrand, 'old'>

const LOGO_BRAND_BY_APP_BRAND: Record<AppBrand, AppLogoDomainBrand> = {
  [AppBrand.Brighterly]: 'new',
  [AppBrand.SmartestMinds]: 'smartest-minds',
}

interface AppLogoDomainReturn {
  logoBrand: AppLogoDomainBrand
}

export const useAppLogoDomain = (): AppLogoDomainReturn => ({
  logoBrand: LOGO_BRAND_BY_APP_BRAND[useRuntimeConfig().public.brand],
})
